<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="tableBox">
                <tabletem :isShowIndex="true" :isHideColumn="false" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @rowClick="rowClick"></tabletem>
            </div>
            <!-- <div class="pagination_path">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div> -->
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">入库方数：{{ statistics.month_in_storage_cube }}m³</div>
                <div class="totalNumber">入库金额：{{ statistics.month_in_storage_amount }}</div>
                <div class="totalNumber">出库方数：{{ statistics.month_out_storage_cube }}m³</div>
                <div class="totalNumber">出库金额：{{ statistics.month_out_storage_amount }}</div>
                <div class="totalNumber">销售方数：{{ statistics.month_sales_cube }}m³</div>
                <div class="totalNumber">销售金额：{{ statistics.month_sales_amount }}</div>
                <div class="totalNumber">营业支出：{{ statistics.business_fee }}</div>
                <div class="totalNumber">公司毛利：{{ statistics.margin }}</div>

            </div>
        </div>
        <!-- <filter-fields :tableData="filter" :scene="'inventory.out.column'" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields> -->
    </div>
</template>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            tabletem,
            pagination,
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleOut:false,
                filterDialogVisible:false,
                filter:"",
                companyName:localStorage.dw_erp_company_name,
                list:[],
                tableCol:[
                    {colName:"报表时间",colKey:"report_time",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"报表详情",colKey:"report_sn",colWidth:120,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"上月结余方数",colKey:"last_month_balance_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"上月结余金额",colKey:"last_month_balance_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月入库方数",colKey:"month_in_storage_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月入库金额",colKey:"month_in_storage_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月出库方数",colKey:"month_out_storage_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月出库金额",colKey:"month_out_storage_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月销售方数",colKey:"month_sales_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月销售金额",colKey:"month_sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月退货方数",colKey:"month_return_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月退货金额",colKey:"month_return_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月结余方数",colKey:"month_balance_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月结余金额",colKey:"month_balance_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月营业支出",colKey:"business_fee",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月毛利",colKey:"margin",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                statistics:{
                    month_in_storage_cube:"",
                    month_in_storage_amount:"",
                    month_out_storage_cube:"",
                    month_out_storage_amount:"",
                    month_sales_cube:"",
                    month_sales_amount:"",
                    business_fe:"",
                    margin:""
                }
            }
        },
        created() {
            this.getList();
        },
        methods:{
            filterConfirm(){
                this.getBillColumn()
            },
            getList(){
                this.tableLoading = true;
                this.postFunc("/erp/finance.month.report",{},response=>{
                    if(response.data.code == 0){
                        this.list = response.data.data.list;
                        // this.total = response.data.data.total;
                        this.statistics = response.data.data.statistics;
                        // this.last_page = response.data.data.last_page;
                        // this.$refs.pagination.flag = true;
                        this.list.forEach((item,index)=>{
                            if(item.contract_time!=0){
                                this.list[index].report_time = this.formatTimeMonth(item.report_time+"000")
                            }else{
                                this.list[index].report_time = ""
                            }
                        })
                        this.tableLoading = false;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                sessionStorage.setItem("DEMU_ERP_FINANCEMONTH_ID",obj.id)
                this.$root.$children[0].$children[0].addTab({
                    name: '财务明细详情'+obj.id,
                    label: '财务明细详情',
                    content: 'financeMonthDetail'
                });
            },
        },
        watch:{
            // "params.page":function(){
            //     this.getList();
            // },
            // "params.per_page":function(){
            //     this.search();
            // }
        }
    }
</script>
